// Node imports
import { dispatcher, ingenuity } from "@quest/base-core";
import { FreeGameState, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist/";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist/";
import { TopLogoControllerFg } from "@quest/murka-games-behavior-leopard/dist/Game/TopLogo/TopLogoControllerFg";
import { SlotEventConstants } from "@quest/slot-core";
import { DisplayObject } from "pixi.js-legacy";

// Class imports
import { View } from "../FreeGame/View";
import { StackSymbolFeatureViewFG } from "../StackFeatureFG/StackSymbolFeatureViewFG";
import { StackSymbolFeatureControllerFG } from "../StackFeatureFG/StackSymbolFeatureControllerFG";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { StickyWildViewFG } from "../WildReelFg/StickyWildViewFG";
import { StickyWildControllerFG } from "../WildReelFg/StickyWildControllerFG";
import { TopLogoViewGameFG } from "../TopLogo/TopLogoViewGameFG";
import { GameParserModel } from "../Platform/GameParserModel";

export class FreeGameStateAT extends FreeGameState {
  protected view: View;
  // Stack Feature
  protected stackSymbolViewFG: StackSymbolFeatureViewFG;
  protected stackSymbolControllerFG: StackSymbolFeatureControllerFG;


  //WildReelsFg
  protected wildReelViewFg: StickyWildViewFG;
  protected wildReelControllerFg: StickyWildControllerFG;

  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.INITIALIZE_FREEGAME_STACK_FEATURE, this.initializeStackSymbolFeatureFG, this);
    dispatcher.on(eventDispatchers.INITIALIZE_WILD_REELS_FG_VIEW, this.initializeWildReelsFgView, this);
  }
  protected unsubscribeEvents(): void {
    super.unsubscribeEvents();
    dispatcher.off(eventDispatchers.INITIALIZE_FREEGAME_STACK_FEATURE, this.initializeStackSymbolFeatureFG, this);
    dispatcher.off(eventDispatchers.INITIALIZE_WILD_REELS_FG_VIEW, this.initializeWildReelsFgView, this);
  }
  /**
   * override to manage SHOW_FREEGAME_VIEW
   */
  public init() {
    this.initializeModel();
    this.initializeView();
    this.initializeReelPanel();
    this.initializePayline();
    this.initializeWinReelPresentation();
    this.initializeOverlayWinReelPresentation();
    this.setReelPanelLayering();
    this.initializeController();
    this.initializeBigWinPresentation();
    this.initializePaytable();
    this.initializeIntroOutro();
    this.initializeSound();
    dispatcher.fireEvent(SlotEventConstants.INITIALIZE_FG_MODEL);
    dispatcher.fireEvent(SlotEventConstants.SETUP_FG);
    if ((ingenuity.parserModel as GameParserModel).getFreeGameBroken()) {
      if ((ingenuity.parserModel as GameParserModel).getIsStickyWildAvailable()) {
        dispatcher.fireEvent(eventDispatchers.INITIALIZE_WILD_REELS_FG_VIEW)
        dispatcher.fireEvent(eventDispatchers.SHOW_STICKY_WILD_ON_BROKEN)
      }
      dispatcher.fireEvent(SlotEventConstants.SHOW_FREEGAME_VIEW);
    }
    dispatcher.fireEvent(SlotEventConstantsBehavior.BRING_GUI_ON_TOP);
    ingenuity.configData.freegameReturning = true;
  }
  /**
   * to initialize fg wild reels feature
   */
  private initializeWildReelsFgView(): void {
    if (!this.wildReelViewFg) {
      this.wildReelViewFg = new StickyWildViewFG(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).WildReelFg);
      this.wildReelControllerFg = new StickyWildControllerFG(this.wildReelViewFg);
      this.setLayering(this.wildReelViewFg);
    }
  }
  // Intialize stack symbol
  protected initializeStackSymbolFeatureFG(): void {
    if (!this.stackSymbolViewFG) {
      this.stackSymbolViewFG = new StackSymbolFeatureViewFG(ingenuity.currentGame.cache.getJSON(SlotConstantsBehavior.MAIN_DATA).stackSymFG);
      this.stackSymbolControllerFG = new StackSymbolFeatureControllerFG(this.stackSymbolViewFG);
      this.setLayering(this.stackSymbolViewFG);
    }
  }
  /**
   * to shut down feature classes
   */
  public shutdown(): void {
    this.wildReelViewFg && this.wildReelViewFg.destroy();
    this.wildReelViewFg = null;
    this.wildReelControllerFg && this.wildReelControllerFg.resetStickyWild();
    this.wildReelControllerFg = null;
    this.stackSymbolViewFG && this.stackSymbolViewFG.destroy();
    this.stackSymbolViewFG = null;
    this.stackSymbolControllerFG && this.stackSymbolControllerFG.reset();
    this.stackSymbolControllerFG = null;
    super.shutdown();
  }
  /**
   * to set win layering
   */
  private setLayering(obj: any) {
    const winBoxIndex: number = this.getWinBoxIndex();
    winBoxIndex && this.winReelpanel.addChildAt(obj, winBoxIndex);
  }

  /**to get winBox Container Index */
  private getWinBoxIndex(): number {
    const winBoxContainer: DisplayObject = this.winReelpanel.getChildByName("winboxContainer");
    if (winBoxContainer) {
      return this.winReelpanel.getChildIndex(winBoxContainer);
    }
  }
  /**initialize top logo view */
  protected initializeGameLogoView() {
    if (!this.topLogoView) {
      this.topLogoView = new TopLogoViewGameFG(ingenuity.assetsData.getJSONById(SlotConstantsBehavior.MAIN_DATA).topLogo, this.view);
      this.topLogoController = new TopLogoControllerFg(this.topLogoView);
    }
    else {
      dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_TOP_GAME_LOGO_FG);
    }
  }
    
}
